import {
  generateBrandShades,
  generateNeutralShades,
  isHexColor,
} from "containers/admin/clients/client/theme-configuration-page/helpers/color-shades";

import type { ThemePalette } from "containers/admin/clients/client/theme-configuration-page/theme-configuration.types";
import type { ColorsFormValues } from "containers/admin/clients/client/theme-configuration-page/brand-identity/colors-tab/colors-tab.types";

import {
  BRAND_COLOR_FIELDS,
  DEFAULT_COLORS_FORM_VALUES,
  HEX_FORMAT_MESSAGE,
} from "containers/admin/clients/client/theme-configuration-page/brand-identity/colors-tab/colors-tab.constants";

export const paletteToColorsFormValues = (palette?: ThemePalette): ColorsFormValues => {
  if (!palette) {
    return DEFAULT_COLORS_FORM_VALUES;
  }

  return {
    brand: {
      primary: palette.brand.primary?.base ?? "",
      secondary: palette.brand.secondary?.base ?? "",
      tertiary: palette.brand.tertiary?.base ?? "",
    },
    neutral: { black: palette.neutral.black.base },
    utility: palette.utility,
  };
};

export const colorsFormValuesToPalette = ({ brand, neutral, utility }: ColorsFormValues): ThemePalette => ({
  brand: Object.fromEntries(
    BRAND_COLOR_FIELDS.filter(({ name }) => isHexColor(brand[name])).map(({ name }) => [
      name,
      { base: brand[name], shades: generateBrandShades(brand[name]) },
    ]),
  ),
  neutral: { black: { base: neutral.black, shades: generateNeutralShades(neutral.black) } },
  utility,
});

/** `#` alone is what the field holds right after the user clears the digits, so it counts as empty. */
export const validateHexColor = (label: string, isRequired: boolean) => (value: string) => {
  if (!value || value === "#") {
    return isRequired ? `${label} color is required` : true;
  }

  return isHexColor(value) || HEX_FORMAT_MESSAGE;
};
